<template>
    <BigTurntable :componentConfig="componentConfig" :platform="platform" :isLogin="isLogin" :remainTimes.sync="remainTimes" @darwLottery="darwLottery" @queryWinRecords='queryWinRecords' @submitWinInfo='submitWinInfo' @beforeIsLogin="beforeIsLogin"/>
</template>

<script>
import { mapState } from "vuex";
import {Toast} from "vant";
import BigTurntable from '@51job/jbs-bigcard-component/lib/BigTurntable.js';
export default {
  name:"ActivityWheel",
  props:{
    componentConfig: {
      type: Object,
      default: () => {},
    },
  },
  components:{BigTurntable},
  data(){
    return{
      remainTimes:0,
      loadingData:true,
    }
  },
  computed: {
    ...mapState(["commonStore"]),
    platform(){
      if(this.commonStore.device == "androidApp" || this.commonStore.device == "iosApp"){
        return 'APP';
      }else if(this.commonStore.device == "wechat"){
        return "WXAPP";
      }else{
        return "PC";
      }
    },
    isLogin() {
      return this.$store.getters.isLogin;
    },
  },
  watch:{
    "commonStore.bigWheelCountRefresh":{//监控需要重新请求转盘次数
      handler(val) {
        if(val){//轮到本组件加载数据了
          this.updateRemainTimes();
          this.$nextTick(() => {
            this.$store.commit("setValueLocalStorage", {
              bigWheelCountRefresh: false,
            });
          });
        }
      },
      immediate: false,
    }
  },
  mounted(){
    if(this.isLogin){
      console.log("设备",this.platform)
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration:0
      });
      this.updateRemainTimes();
    } 
  },
  methods:{
    async updateRemainTimes(){//更新抽奖次数
      let res = await this.$api.activity.lotteryTimes({
        componentId: this.componentConfig.id,
        activityId: this.componentConfig.activityId, //活动id
      });
      if (res?.code == "0" && res?.data) {
        this.remainTimes = res.data.remainTimes;  
      }
      Toast.clear();
    },
    async darwLottery(callback,beforeDarw,startPlayWheel){//抽奖
      if(this.isLogin){
        if(!beforeDarw()){
          return false;
        }
        try{
          startPlayWheel();
          let res = await this.$api.activity.darwLottery({
            componentId: this.componentConfig.id,
            activityId: this.componentConfig.activityId, //活动id
          });
          if (res?.code == "0" && res?.data) {
            callback(res.data);
          }else{
            callback(false);
          }
        }catch(error){
          console.log("抽奖失败");
          callback(false);
        } 
      }else{
        this.$base.toLogin();//先登录
      }      
    },
    async queryWinRecords(callback){//中奖记录
      try{
        let res = await this.$api.activity.queryWinRecords({
          componentId: this.componentConfig.id,
          activityId: this.componentConfig.activityId, //活动id
        });
        if (res?.code == "0" && res?.data) {
          callback(res.data);
        }else{
          callback(false);
        }
      }catch(error){
        console.log("中奖记录获取失败");
        callback(false);
      }    
    },
    async submitWinInfo(tel,winRecordId,callback){//用户提交领奖信息
      try{
        let res = await this.$api.activity.submitWinInfo({
          mobile:tel,
          winRecordId: winRecordId,
          activityId: this.componentConfig.activityId, //活动id
        });
        if (res?.code == "0" && res?.data) {
          callback(res.data);
        }else{
          callback(false);
        }
      }catch(error){
        console.log("提交手机号失败");
        callback(false);
      }    
    },
    beforeIsLogin(callback){//用户未登录的操作
      if(!this.isLogin){
        this.$base.toLogin();//先登录
        callback(false);
      }else{
        callback(true);
      }
    }
  }
}

</script>
<style lang='css' scoped>
</style>